module.exports = __webpack_public_path__ + "static/media/qsbn.f2df17af.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/qsbn.webp
// module id = 380
// module chunks = 0